import React from "react";
import { Radio, RadioGroup, FormControlLabel, Typography, InputLabel, Box } from "@mui/material";
import CustomDivider from "../../utils/CustomDivider";

const RadioButtonGroup = ({ options, value, onChange, row = false, label }) => {
  return (
    <Box sx={{display:"flex",flexDirection:"column"}}>
      {label && (
        <InputLabel>
          <Typography variant="h6" sx={{ textTransform: "capitalize" }}>
            {label}
          </Typography>
        </InputLabel>
      )}
    
      <RadioGroup
        row={row}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={
              <Radio
                sx={{
                  color: "#4169E1",
                  '&.Mui-checked': { color: "#4169E1" },
                }}
              />
            }
            label={
              <Typography
                variant="body2"
                fontSize={{ xs: "10px", sm: "16px" }}
              >
                {option.label}
              </Typography>
            }
          />
        ))}
      </RadioGroup>
    </Box>
  );
};

export default RadioButtonGroup;
